"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var $dyn;
(function ($dyn) {
    var controls;
    (function (controls) {
        /*
         * Framework class for the MessageBar controls section
         */
        var MessageBarSection = /** @class */ (function (_super) {
            __extends(MessageBarSection, _super);
            function MessageBarSection() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            MessageBarSection.prototype.init = function (data, element) {
                var _this = this;
                _super.prototype.init.call(this, data, element);
                this.EntranceAnimation = "messageBar-grow";
                this.ExitAnimation = "messageBar-shrink";
                this.ContentAnimation = "fadeIn";
                this._marginApplied = false;
                if ($dyn.flags.disableAnimations) {
                    this.element.classList.add("allowScrolling");
                    var oldIsVisible_1 = $dyn.value(this.IsVisible);
                    $dyn.observe(this.IsVisible, function (value) {
                        if (value !== oldIsVisible_1) {
                            // Since the available space has changed we need to tell
                            // components outside the message bar to update.
                            if (_this.Root) {
                                _this.Root.reflow();
                            }
                            oldIsVisible_1 = value;
                        }
                    }, this, undefined, true);
                }
                else {
                    var messageRegion_1 = this.element.querySelector(".messageBar-messageRegion");
                    this.entranceAnimationEnd = function (event) {
                        if (event.target === _this.element && event.animationName === _this.EntranceAnimation) {
                            messageRegion_1.classList.remove(_this.ContentAnimation);
                            _this.element.removeEventListener("animationend", _this.entranceAnimationEnd, false);
                            _this.element.removeEventListener("webkitAnimationEnd", _this.entranceAnimationEnd, false);
                            // Since the available space has changed we need to tell
                            // components outside the message bar to update.
                            if (_this.Root) {
                                _this.Root.reflow();
                            }
                            // If the margin was not applied in the post render, try it after the animation
                            if (!_this._marginApplied) {
                                _this.PostRenderSection();
                            }
                        }
                    };
                    // Turn off scrollbars until the transition to open is finished
                    this.transitionEnd = function (event) {
                        if (event.target === _this.element && event.propertyName === "max-height") {
                            if ($dyn.value(_this.Expanded)) {
                                _this.element.classList.add("allowScrolling");
                            }
                            else {
                                _this.element.classList.remove("allowScrolling");
                            }
                        }
                    };
                    this.element.classList.add(this.EntranceAnimation);
                    messageRegion_1.classList.add(this.ContentAnimation);
                    this.element.addEventListener("transitionend", this.transitionEnd, false);
                    this.element.addEventListener("animationend", this.entranceAnimationEnd, false);
                    this.element.addEventListener("webkitAnimationEnd", this.entranceAnimationEnd, false);
                }
            };
            MessageBarSection.prototype.ClearMessages = function () { };
            MessageBarSection.prototype.PreRenderSection = function () {
                this._marginApplied = false;
            };
            /**
             * Applies the margin to the first message to allow space for the buttons after the foreach is done rendering
             */
            MessageBarSection.prototype.PostRenderSection = function () {
                if ($dyn.value(this.IsToggleVisible)) {
                    var firstMessage = this.element.querySelector(".messageBar-messageEntry");
                    if (firstMessage) {
                        var margin = this._getCollapseRegionWidth();
                        if (margin) {
                            if ($dyn.util.isRTLMode()) {
                                firstMessage.style.marginLeft = this._getCollapseRegionWidth() + "px";
                            }
                            else {
                                firstMessage.style.marginRight = this._getCollapseRegionWidth() + "px";
                            }
                            this._marginApplied = true;
                        }
                    }
                }
            };
            /**
             * Performs the exit animation then calls ClearMessages
             */
            MessageBarSection.prototype.ClearSectionMessages = function () {
                var _this = this;
                if ($dyn.flags.disableAnimations) {
                    this.ClearMessages();
                }
                else {
                    this.exitAnimationEnd = function (event) {
                        if (event.target === _this.element && event.animationName === _this.ExitAnimation) {
                            _this.ClearMessages();
                            _this.element.classList.remove(_this.ExitAnimation);
                            _this.element.removeEventListener("animationend", _this.exitAnimationEnd, false);
                            _this.element.removeEventListener("webkitAnimationEnd", _this.exitAnimationEnd, false);
                            _this.element.classList.add(_this.EntranceAnimation);
                            _this.element.addEventListener("animationend", _this.entranceAnimationEnd, false);
                            _this.element.addEventListener("webkitAnimationEnd", _this.entranceAnimationEnd, false);
                            // Since the available space has changed we need to tell
                            // components outside the message bar to update.
                            if (_this.Root) {
                                _this.Root.reflow();
                            }
                        }
                    };
                    this.element.classList.remove(this.EntranceAnimation);
                    this.element.classList.add(this.ExitAnimation);
                    this.element.addEventListener("animationend", this.exitAnimationEnd, false);
                    this.element.addEventListener("webkitAnimationEnd", this.exitAnimationEnd, false);
                }
                this.Root.RestoreFocusToMainFormContainer();
            };
            MessageBarSection.prototype.dispose = function () {
                if (this.entranceAnimationEnd) {
                    if (this.element) {
                        this.element.removeEventListener("animationend", this.entranceAnimationEnd, false);
                        this.element.removeEventListener("webkitAnimationEnd", this.entranceAnimationEnd, false);
                    }
                    this.entranceAnimationEnd = null;
                }
                if (this.transitionEnd) {
                    if (this.element) {
                        this.element.removeEventListener("transitionend", this.transitionEnd, false);
                    }
                    this.transitionEnd = null;
                }
                if (this.exitAnimationEnd) {
                    if (this.element) {
                        this.element.removeEventListener("animationend", this.exitAnimationEnd, false);
                        this.element.removeEventListener("webkitAnimationEnd", this.exitAnimationEnd, false);
                    }
                    this.exitAnimationEnd = null;
                }
                _super.prototype.dispose.call(this);
            };
            /**
             * Gets the region width of the div containing the toggle expand and clear buttons
             */
            MessageBarSection.prototype._getCollapseRegionWidth = function () {
                if (!this._cachedCollapseRegionWidth) {
                    var collapseRegion = this.element.querySelector(".messageBar-collapseMessageRegion");
                    if (collapseRegion) {
                        this._cachedCollapseRegionWidth = collapseRegion.offsetWidth;
                    }
                }
                return this._cachedCollapseRegionWidth;
            };
            return MessageBarSection;
        }($dyn.ui.Control));
        controls.MessageBarSection = MessageBarSection;
    })(controls = $dyn.controls || ($dyn.controls = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=MessageBarSection.js.map
